export const FormatoInscripcionLang = {
    // ENCABEZADO
    codigoP: {
        es: 'Código',
        en: 'Code',
    },

    Title: {
        es: 'SOLICITUD DE CRÉDITO / NUEVO CLIENTE',
        en: 'CREDIT APPLICATION / NEW CLIENT',
    },

    Date: {
        es: 'Fecha: ',
        en: 'Date: ',
    },
    Version: {
        es: 'Versión: ',
        en: 'Version: ',
    },
    textInitial: {
        es: 'Por favor complete este formulario y firme en el borde de todas las páginas por el representante legal. Los datos requeridos son esenciales y deben reflejar la información actual de la empresa. La información que usted proporcione y la declaración de la exactitud de la información se mantendrán estrictamente confidenciales dentro de nuestro departamento de crédito. Cualquier situación especial por favor consulte con su gerente de cuenta.',
        en: 'Please complete this form and sign on the edge of all the pages by the legal representative. The required data is essential and should reflect the current information of the company. The information you provide and the declaration of the accuracy of the information will be kept strictly confidential within our credit department. Any special situation please consult your account manager.: ',
    },

    // TABLA PRINCIPAL
    parteI: {
        en: '1. CREDIT APPLICATION / UPDATE',
        es: '1. SOLICITUD DE CRÉDITO / ACTUALIZACIÓN',
    },
    dateA: {
        en: 'Date of Update / Application:',
        es: 'Fecha de actualización / Solicitud:',
    },
    name: {
        es: 'Nombre de la Organización: ',
        en: 'Name of the Organitation: ',
    },
    address: {
        es: 'Dirección: ',
        en: 'Address: ',
    },
    invoice: {
        es: 'Facturas a ser facturadas a: ',
        en: 'Invoices to be Billed To: ',
    },
    billed: {
        es: 'Correo de envío de Facturas: ',
        en: 'Invoice sending email: ',
    },
    business: {
        es: 'Código Identificador de Negocio: (R.T.N./SIN/NIT/RFC/RTU): ',
        en: 'Business Identifier code: (R.T.N./SIN/NIT/RFC/RTU): ',
    },
    Tel: {
        es: 'Teléfono: ',
        en: 'Phone: ',
    },
    TelT: {
        es: 'Teléfono',
        en: 'Phone',
    },
    Email: {
        es: 'Correo: ',
        en: 'Email: ',
    },
    Representante: {
        es: 'Representante Legal de la Empresa: ',
        en: 'Company´s Legal Representative: ',
    },
    TipoPago: {
        es: 'Solicitar Crédito: ',
        en: 'Request Credit: ',
    },
    Si: {
        es: 'Si',
        en: 'Yes',
    },
    Nombre: {
        es: 'Nombre: ',
        en: 'Name: ',
    },
    InfFinanciera: {
        es: 'Información de contactos de finanzas',
        en: 'Finance contact information',
    },

    MetodoPago: {
        es: 'Metodo de Pago: ',
        en: 'Payment Method: ',
    },

    Identificacion: {
        es: 'Identificación',
        en: 'Identification',
    },
    NoDatosDirectores: {
        es: 'No se han agregado directores.',
        en: 'No directors have been added.',
    },
    NoDatosAccionistas: {
        es: 'No se han agregado accionistas.',
        en: 'No shareholders have been added.',
    },
    NoDatosBancarios: {
        es: 'No se han agregado datos bancarios.',
        en: 'No bank details added.',
    },
    NoDatosReferencias: {
        es: 'No se han referencias comerciales.',
        en: 'There are no commercial references.',
    },
    NoDatosCuentas: {
        es: 'No se han agregado datos de cuentas por pagar.',
        en: 'No accounts payable data added.',
    },

    BankName: {
        es: 'Nombre de Banco',
        en: 'Bank Name',
    },

    //---------------------------------------
    parteII: {
        es: '2. ADMINISTRACIÓN Y ESTRUCTURA ACCIONARIA',
        en: '2. ADMINISTRATION AND SHAREHOLDING STRUCTURE',
    },
    directores: {
        es: 'Directores principales o altos directivos de la empresa',
        en: 'Main directors or senior management of the company',
    },
    accionistas: {
        es: 'Estructura accionaria',
        en: 'Shareholding Structure',
    },
    Porcentaje: {
        es: 'Porcentaje Participación',
        en: 'Percentage of ownership',
    },

    parteIV: {
        es: '4. DEPARTAMENTO U OFICINA RESPONSABLE DE RECIBIR FACTURAS Y PAGOS',
        en: '4. DEPARTMENT OR OFFICE RESPONSIBLE FOR RECEIVING INVOICES AND PAYMENTS',
    },
    parteIV_1: {
        es: '2. DEPARTAMENTO U OFICINA RESPONSABLE DE RECIBIR FACTURAS Y PAGOS',
        en: '2. DEPARTMENT OR OFFICE RESPONSIBLE FOR RECEIVING INVOICES AND PAYMENTS',
    },
    accounts: {
        es: '4.1 Contacto cuentas por pagar',
        en: '4.1 Accounts Payable Contact',
    },
    accounts_1: {
        es: '2.1 Contacto cuentas por pagar',
        en: '2.1 Accounts Payable Contact',
    },
    parteV: {
        es: '5. DOCUMENTOS REQUERIDOS',
        en: '5. REQUIRED DOCUMENTS',
    },
    parteV_1: {
        es: '3. DOCUMENTOS REQUERIDOS',
        en: '3. REQUIRED DOCUMENTS',
    },
    req51: {
        es: 'Copia de Identificación (R.T.N./SIN/NIT/RFC/RTU)',
        en: 'Copy of TAX ID (R.T.N./SIN/NIT/RFC/RTU)',
    },
    req52: {
        es: 'Copia del Acta Constitutiva.',
        en: 'Copy of Articles of Incorporation.',
    },
    req53: {
        es: 'Estados financieros de los últimos seis meses.',
        en: 'Financial statements for the last six months.',
    },
    req54: {
        es: 'Recibo de servicios públicos.',
        en: 'Public services receipt.',
    },
    req55: {
        es: 'Encabezado de factura.',
        en: 'Invoice header.',
    },
    req56: {
        es: 'Licencia de funcionamiento vigente.',
        en: 'Valid operating license.',
    },
    req57: {
        es: 'Certificados de cumplimiento ambiental vigentes.',
        en: 'Valid environmental compliance certificates.',
    },
    req58: {
        es: 'Certificados de cumplimiento laboral vigentes..',
        en: 'Valid labor compliance certificates.',
    },
    req59: {
        es: 'Identificación personal de representante legal',
        en: 'Personal identification of legal representative.',
    },
    req510: {
        es: 'Los Clientes Nacionales tambien deberán proporcionar:',
        en: 'National Customers must provide also: ',
    },
    req: {
        en: '- Exonerated Registry.',
        es: '- Registro de Exonerados.',
    },

    req1: {
        en: '- Proof of payments on account.',
        es: '- Constancia de pagos a cuenta.',
    },

    parteVI: {
        es: '6. TRANSACCIONES DE CRÉDITO',
        en: '6. CREDIT TRANSACTIONS',
    },
    parteVI_1: {
        es: '4. TRANSACCIONES DE CRÉDITO',
        en: '4. CREDIT TRANSACTIONS',
    },
    req61: {
        es: 'Nuestra empresa ofrece a los nuevos clientes un plazo de crédito de 15 días, después de la carta firmada de contabilidad general.',
        en: 'Our company provides New customers 15 days credit deadline, after general accounting signed letter.',
    },
    req62: {
        es: 'Nuestra información bancaria se enviará al contacto de cuenta a pagar proporcionado',
        en: 'Our Bank information will be sent to the provided Account Payable Contact',
    },
    req62_1: {
        es: 'Contacto de cuenta a pagar proporcionado',
        en: 'Account Payable Contact',
    },
    req63: {
        es: 'Las facturas emitidas antes de la firma del contrato se pagarán al recibirlas.',
        en: 'The invoices issued previous to the contract signature are paid due on receipt.',
    },
    parteVII: {
        es: '7. ACEPTACIÓN DE CRÉDITO',
        en: '7. CREDIT ACEPTANCE',
    },
    parteVII_1: {
        es: '5. ACEPTACIÓN DE CRÉDITO',
        en: '5. CREDIT ACEPTANCE',
    },
    req71: {
        es: 'Declaro que la información anterior es correcta. Entiendo que “CAMDEN Spinning Mills S.A. de C.V", podrá contactar y/o utilizar otras fuentes que le permitan investigar la información crediticia que considere necesaria para este fin. Autorizar a las empresas comerciales listadas en esta solicitud a divulgar lo necesario para ayudar a “CAMDEN Spinning Mills S.A. de C.V", a establecer una línea de crédito.',
        en: 'I declare that the above information is correct. I understand that "CAMDEN Spinning Mills S.A. de C.V", may contact and / or use other sources to enable it to investigate credit information deemed necessary for this purpose. Authorize commercial companies listed in this application to disclose the necessary to help "CAMDEN Spinning Mills S.A. de C.V", to establish a line of credit.',
    },
    req72: {
        es: 'Nos comprometemos a respetar las condiciones de pago especificadas en la Política de Crédito. (adjunto).',
        en: 'We agree to honor the terms of payment specified in the Credit Policy. (attached).',
    },

    nombreRepresentante: {
        es: 'Nombre del Representante Legal',
        en: 'Name of the Legal Representative',
    },
    signature: {
        es: 'Firma',
        en: 'Signature',
    },
    solicitudFirmadaText: {
        es: 'Por favor devuelva esta solicitud firmada y sellada a su Gerente de Cuenta y/o al Departamento de Crédito de "CAMDEN Spinning Mills S.A. de C.V" a través del correo electrónico: ',
        en: 'Please return this application signed and stamped to your Account Manager and / or the Credit Department at "CAMDEN Spinning Mills S.A. de C.V" through e-mail: ',
    },

    parteVIII: {
        es: 'PARA USO EXCLUSIVO DE CAMDEN Spinning Mills ',
        en: 'FOR CAMDEN Spinning Mills  USE ONLY',
    },
    validada: {
        es: '¿La información ha sido validada?',
        en: 'The information has been validated?',
    },
    Yes: {
        es: 'Sí',
        en: 'Yes',
    },
    plazo: {
        es: 'Plazo de crédito aprobado: ',
        en: 'Credit deadline approved: ',
    },
    limite: {
        es: 'Límite de Crédito: ',
        en: 'Limit of Credit: ',
    },

    autorizada: {
        es: 'Autorizado Por',
        en: 'Authorised By',
    },
    evaluada: {
        es: 'Evaluado Por',
        en: 'Evaluated By',
    },





    NombreT: {
        es: 'Nombre',
        en: 'Name',
    },
    
    NombreContacto: {
        es: 'Nombre Contacto',
        en: 'Contact Name',
    },
    
    Posicion: {
        es: 'Posición',
        en: 'Position',
    },
    EmailT: {
        es: 'Correo',
        en: 'Email',
    },
    Nacionalidad: {
        es: 'Nacionalidad',
        en: 'Nacionality',
    },

    
    parteIII: {
        es: '3. REFERENCIAS BANCARIAS Y COMERCIALES',
        en: '3. BANK AND TRADE REFERENCES',
    },
    customer: {
        es: '3.1 Referencias Comerciales',
        en: '3.1 Commercial References',
    },
    bancos: {
        es: '3.2 Información Bancaria',
        en: '3.2 Banking Information',
    },
    NombreC : {
        es: 'Nombre de Compañía',
        en: 'Company Name',
    },



    casaMatriz: {
        es: 'Nombre de la casa matriz',
        en: 'Name of parent company',
    },
    pais: {
        es: 'País de constitución',
        en: 'Country of incorporation',
    },
    identificacionTributaria: {
        es: 'Número de Identificación Tributaria',
        en: 'Tax Identification',
    },
    nombre: {
        es: 'Nombre Comercial (Si es distinto al nombre comercial)',
        en: 'Commercial Name (If different from the commercial name)',
    },
    direccionC: {
        es: 'Dirección comercial (Si es distinto al anterior)',
        en: 'Commercial address (If different from the previous one)',
    },
    nTel: {
        es: 'Número de teléfono de referencia',
        en: 'Reference telephone number',
    },
    contacto: {
        es: 'Contacto de cuentas por cobrar (Persona encargada de confirmar pagos):',
        en: 'Accounts Receivable Contact (Person in charge of confirming payments):',
    },
    representanteL: {
        es: 'Representante legal:',
        en: 'Legal representative:',
    },
    actividad: {
        es: 'Prinncipal actividad económica:',
        en: 'Main economic activity:',
    },

    nombreC: {
        es: 'Nombre de la compañía',
        en: ' Name of the company',
    },

    text3: {
        es: '*Esta información es muy importante. Los datos se validaran mediante llamada telefónica al recibir el formulario completo.',
        en: '*This information is very important. The data will be validated by phone call upon receipt of the completed form.',
    },
    bancoI: {
        es: 'BANCO INTERMEDIARIO',
        en: 'INTERMEDIARY BANK',
    },
    nombreB: {
        es: 'Nombre del Banco:',
        en: 'Name of the bank:',
    },
    direccionB: {
        es: 'Dirección del banco:',
        en: 'Bank address:',
    },
    numeroCuenta: {
        es: 'Número de cuenta:',
        en: 'Account number:',
    },
    bancoB: {
        es: 'BANCO BENEFICIARIO',
        en: 'BENEFICIARY BANK',
    },
    nombreBeneficiario: {
        es: 'Nombre del Beneficiario:',
        en: 'Name of Beneficiary:',
    },









}